module.exports = __webpack_public_path__ + "img/setChecked.3f965187.png";